import React from 'react';
import { navigate } from 'gatsby';

//CORE COMPONENTS
import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';

import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { Layout } from '../../../components-core/packages/components-core/dist/layout/index'
import { Link, LinkButton } from '../../../components-core/packages/components-core/dist/link/index';
import { LazyImage } from '../../../components-core/packages/components-core/dist/image/index';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container/index';

//ICONS CORE
import { ArrowRight } from '../../../components-core/packages/icons-core/dist/ArrowRight/index';

//3RD PARTY
import Slider from "react-slick";

import { encodeHTMLEntities } from '../../helpers/encoders/Encoder';


const OpacityContainer = styled.div`
    opacity: ${props => props.opacity};
`;

const MobileImageContainer = styled.div`
    width: 400px;
    height: 400px;
    object-fit: cover;
`;


class HomeModelGroup extends React.Component {

    constructor() {
        super();
        this.state = {
            currentSlide: 0
        }
    }

    renderSection() {
        const objectsWithData = demoObjects(this.props);

        return objectsWithData.map(obj => 
            <Container 
                stretchContent={true}  
                wrap={ContainerWrap.always} 
                padding={mobileContainerPadding}
            >
                {obj.custom.map((link, index) => this.renderObject(link, index))}
            </Container>            
        )      
    }

    renderSectionMobile() {
        let objects = [];
        let objectsWithData = demoObjects(this.props);
        objectsWithData.forEach(obj => 
            obj.custom.forEach(link => objects.push(link))
        )      

        return objects.map((object, index) => this.renderObject(object, index))
    }

    renderImage(source) {
        const image = <LazyImage srcPlaceholder={source} src={source} alt={'vw'} sizes="(max-width: 768px) 320px, 1440px" />

        return (
            <Container stretchContent={true} padding={{ bottom: ContainerPadding.dynamic0100 }} >
                <BreakpointWrapper max={Breakpoints.b560}>
                        {image}
                </BreakpointWrapper>
                <BreakpointWrapper min={Breakpoints.b560}>
                    {image}
                </BreakpointWrapper>
            </Container>
        )
    }

    renderDescriptions(data) {
        return (
            <Container 
                wrap={ContainerWrap.always} 
                gutter={ContainerGutter.static250}
                padding={{ bottom: ContainerPadding.dynamic0100 }}
            >
                {
                    data.carModel && (
                        <Text bold appearance={TextAppearance.label0150} >
                            <Link href={data.discoverlink} target="_blank">{data.carModel}</Link>
                        </Text>
                    )
                }
                {
                    data.title && (
                        <Text appearance={TextAppearance.headline0250} bold>
                            {data.title}
                        </Text>
                    )
                }
                {
                    data.description && (
                        <Text appearance={TextAppearance.copy0150} >
                            {data.description}
                        </Text>
                    )
                }
                {renderLinkButtons('Fiyat Listesi', data.pricelink)}
                {renderLinkButtons('Keşfet', data.discoverlink)}
            </Container>
        )
    }
    
    renderObject(data, index) {
        const currentSlide = this.state.currentSlide;

        return (
            <Container padding={mobileContainerPadding}>
                <OpacityContainer 
                    opacity={typeof window !== 'undefined' && window.innerWidth > 560 ? 1 : index === currentSlide ? 1 : 0.4 } 
                >
                    {this.renderImage(data.photo)}
                    {this.renderDescriptions(data)}
                </OpacityContainer>
            </Container>
        )
    }

    renderLayout() {
        return (
            <Layout appearance={layoutBreakpoints} >
                {this.renderSection()}
            </Layout>
        )
    }

    renderSlider() {
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1.3,
            slidesToScroll: 1,
            beforeChange: (current, next) => 
                this.setState({ currentSlide: next }),
          };

        return (
            <Slider {...settings}>
                {this.renderSectionMobile()}
            </Slider>
        )  
    }

    render() {
        return (
            <Container padding={{ bottom: ContainerPadding.dynamic0250 }}>
                <BreakpointWrapper min={Breakpoints.b560}>
                    {this.renderLayout()}
                </BreakpointWrapper>
                <BreakpointWrapper max={Breakpoints.b560}>
                    {this.renderSlider()}
                </BreakpointWrapper>
            </Container>
        )
    }
}

const renderLinkButtons = (text, link) => {

    if (link) {
        return (
            <Text bold appearance={TextAppearance.label0250}>
                <LinkButton onClick={() => {navigate(link)}} href={link} isInline iconRight={<ArrowRight variant="small" />}>
                    {text}
                </LinkButton>
            </Text>
        ) 
    }
}


const layoutBreakpoints = {
    [Breakpoints.default]: [
        {name: 'b', columns: 24},
        {name: 'd', columns: 24},
        {name: 'f', columns: 24},
    ],
    [Breakpoints.b560]: [
        {name: '.', columns: 2},
        {name: 'b', columns: 6},
        {name: '.', columns: 1},
        {name: 'd', columns: 6},
        {name: '.', columns: 1},
        {name: 'f', columns: 6},
        {name: '.', columns: 2},
    ]
}

const mobileContainerPadding = {
    bottom: ContainerPadding.dynamic0100,
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: null
    }
}

const demoObjects = (props) => 
[
    {   
        custom:
            [
                {
                    'carModel': encodeHTMLEntities(props.custom.slice(0, props.custom.indexOf('-'))),
                    'title': encodeHTMLEntities(props.custom.slice(props.custom.indexOf('-') + 1, props.custom.length)),
                    'price': encodeHTMLEntities(props.custom25),
                    'description': encodeHTMLEntities(props.custom5),
                    'photo': props.custom10,
                    'pricelink': props.custom15,
                    'discoverlink': props.custom20
                },
                {
                    'carModel': encodeHTMLEntities(props.custom1.slice(0, props.custom1.indexOf('-'))),
                    'title': encodeHTMLEntities(props.custom1.slice(props.custom1.indexOf('-') + 1, props.custom1.length)),
                    'price': encodeHTMLEntities(props.custom26),
                    'description': encodeHTMLEntities(props.custom6),
                    'photo': props.custom11,
                    'pricelink': props.custom16 ,
                    'discoverlink': props.custom21
                }
            ]
    },
    {   
        custom:
            [
                {
                    'carModel': encodeHTMLEntities(props.custom2.slice(0, props.custom2.indexOf('-'))),
                    'title': encodeHTMLEntities(props.custom2.slice(props.custom2.indexOf('-') + 1, props.custom2.length)),
                    'price': encodeHTMLEntities(props.custom27),
                    'description': encodeHTMLEntities(props.custom7),
                    'photo': props.custom12,
                    'pricelink': props.custom17,
                    'discoverlink': props.custom22
                },
            ],
    },
    {   
        custom:
            [
                {
                    'carModel': encodeHTMLEntities(props.custom3.slice(0, props.custom3.indexOf('-'))),
                    'title': encodeHTMLEntities(props.custom3.slice(props.custom3.indexOf('-') + 1, props.custom3.length)),
                    'price': encodeHTMLEntities(props.custom28),
                    'description': encodeHTMLEntities(props.custom8),
                    'photo': props.custom13,
                    'pricelink': props.custom18,
                    'discoverlink': props.custom23
                },
                {
                    'carModel': encodeHTMLEntities(props.custom4.slice(0, props.custom4.indexOf('-'))),
                    'title': encodeHTMLEntities(props.custom4.slice(props.custom4.indexOf('-') + 1, props.custom4.length)),
                    'price': encodeHTMLEntities(props.custom29),
                    'description': encodeHTMLEntities(props.custom9),
                    'photo': props.custom14,
                    'pricelink': props.custom19,
                    'discoverlink': props.custom24
                }
            ]
    }
]

export default HomeModelGroup;
